import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import s from './TeacherThemes.module.css';

const EMPTY_FORM = {
  tartib: '',
  nomi_uz: '', nomi_ru: '', nomi_en: '',
  short_text_uz: '', short_text_ru: '', short_text_en: '',
  key_word_uz: '', key_word_ru: '', key_word_en: '',
  videolink_uz: '', videolink_ru: '', videolink_en: '',
  maruza_matn_uz: '', maruza_matn_ru: '', maruza_matn_en: '',
  test_soni: '', test_min_soni: '',
  mrasmi_uz: null, maruza_file_uz: null,
};

export const TeacherThemes = () => {
  const { user } = useAuth();
  const token = localStorage.getItem('token');

  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('list'); // 'list' | 'form'
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState('uz');

  const imgRef = useRef();
  const fileRef = useRef();

  const fetchThemes = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.aiassessment.uz/api/kurs-mavzulari/?kurs=2', {
        headers: { Authorization: `Token ${token}` },
      });
      const data = await res.json();
      setThemes(Array.isArray(data) ? data.sort((a, b) => a.tartib - b.tartib) : []);
    } catch {
      setError("Ma'lumotlarni yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchThemes(); }, []);

  const openCreate = () => {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setError('');
    setSuccess('');
    setView('form');
  };

  const openEdit = (theme) => {
    setForm({
      tartib: theme.tartib ?? '',
      nomi_uz: theme.nomi_uz ?? '', nomi_ru: theme.nomi_ru ?? '', nomi_en: theme.nomi_en ?? '',
      short_text_uz: theme.short_text_uz ?? '', short_text_ru: theme.short_text_ru ?? '', short_text_en: theme.short_text_en ?? '',
      key_word_uz: theme.key_word_uz ?? '', key_word_ru: theme.key_word_ru ?? '', key_word_en: theme.key_word_en ?? '',
      videolink_uz: theme.videolink_uz ?? '', videolink_ru: theme.videolink_ru ?? '', videolink_en: theme.videolink_en ?? '',
      maruza_matn_uz: theme.maruza_matn_uz ?? '', maruza_matn_ru: theme.maruza_matn_ru ?? '', maruza_matn_en: theme.maruza_matn_en ?? '',
      test_soni: theme.test_soni ?? '', test_min_soni: theme.test_min_soni ?? '',
      mrasmi_uz: null, maruza_file_uz: null,
    });
    setEditingId(theme.id);
    setError('');
    setSuccess('');
    setView('form');
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) setForm(p => ({ ...p, [name]: files[0] }));
    else setForm(p => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    const body = new FormData();
    body.append('kurs', 2);
    body.append('tartib', form.tartib);
    body.append('test_description_uz', '');
    body.append('test_description_ru', '');
    body.append('test_description_en', '');

    const textFields = [
      'nomi_uz','nomi_ru','nomi_en',
      'short_text_uz','short_text_ru','short_text_en',
      'key_word_uz','key_word_ru','key_word_en',
      'videolink_uz','videolink_ru','videolink_en',
      'maruza_matn_uz','maruza_matn_ru','maruza_matn_en',
      'test_soni','test_min_soni',
    ];
    textFields.forEach(f => body.append(f, form[f] ?? ''));

    if (form.mrasmi_uz) body.append('mrasmi_uz', form.mrasmi_uz);
    if (form.maruza_file_uz) body.append('maruza_file_uz', form.maruza_file_uz);

    try {
      const url = editingId
        ? `https://api.aiassessment.uz/api/kurs-mavzulari/${editingId}/`
        : 'https://api.aiassessment.uz/api/kurs-mavzulari/';
      const method = editingId ? 'PATCH' : 'POST';

      const res = await fetch(url, {
        method,
        headers: { Authorization: `Token ${token}` },
        body,
      });

      if (!res.ok) {
        const err = await res.json();
        setError(JSON.stringify(err));
      } else {
        setSuccess(editingId ? 'Mavzu yangilandi!' : 'Mavzu qo\'shildi!');
        await fetchThemes();
        setTimeout(() => setView('list'), 1200);
      }
    } catch {
      setError('Server bilan bog\'lanishda xatolik');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await fetch(`https://api.aiassessment.uz/api/kurs-mavzulari/${deleteId}/`, {
        method: 'DELETE',
        headers: { Authorization: `Token ${token}` },
      });
      setDeleteId(null);
      await fetchThemes();
    } catch {
      setError('O\'chirishda xatolik');
    }
  };

  const tabs = [
    { key: 'uz', label: 'UZ' },
    { key: 'ru', label: 'RU' },
    { key: 'en', label: 'EN' },
  ];

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Mavzular boshqaruvi</h1>
        {view === 'list' ? (
          <button className={s.btnPrimary} onClick={openCreate}>+ Yangi mavzu</button>
        ) : (
          <button className={s.btnSecondary} onClick={() => setView('list')}>← Ro'yxatga qaytish</button>
        )}
      </div>

      {view === 'list' && (
        <>
          {loading ? (
            <p className={s.loading}>Yuklanmoqda...</p>
          ) : (
            <div className={s.tableWrapper}>
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tartib</th>
                    <th>Nomi (UZ)</th>
                    <th>Ta'rifi</th>
                    <th>Test soni</th>
                    <th>Amallar</th>
                  </tr>
                </thead>
                <tbody>
                  {themes.length === 0 && (
                    <tr><td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>Mavzular yo'q</td></tr>
                  )}
                  {themes.map((th, idx) => (
                    <tr key={th.id}>
                      <td>{idx + 1}</td>
                      <td><span className={s.badge}>{th.tartib}</span></td>
                      <td className={s.tdTitle}>{th.nomi_uz}</td>
                      <td className={s.tdDesc}>{th.short_text_uz?.slice(0, 60)}{th.short_text_uz?.length > 60 ? '…' : ''}</td>
                      <td>{th.test_soni}</td>
                      <td className={s.tdActions}>
                        <button className={s.btnEdit} onClick={() => openEdit(th)}>✏️</button>
                        <button className={s.btnDelete} onClick={() => setDeleteId(th.id)}>🗑</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {view === 'form' && (
        <form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.formTitle}>{editingId ? 'Mavzuni tahrirlash' : 'Yangi mavzu qo\'shish'}</h2>

          {/* Tartib va test */}
          <div className={s.row}>
            <div className={s.field}>
              <label>Tartib raqami *</label>
              <input type="number" name="tartib" value={form.tartib} onChange={handleChange} required className={s.input} />
            </div>
            <div className={s.field}>
              <label>Test soni</label>
              <input type="number" name="test_soni" value={form.test_soni} onChange={handleChange} className={s.input} />
            </div>
            <div className={s.field}>
              <label>Min to'g'ri javob</label>
              <input type="number" name="test_min_soni" value={form.test_min_soni} onChange={handleChange} className={s.input} />
            </div>
          </div>

          {/* Til tablar */}
          <div className={s.langTabs}>
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                className={`${s.langTab} ${activeTab === tab.key ? s.langTabActive : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {tabs.map(tab => (
            <div key={tab.key} className={activeTab === tab.key ? s.tabContent : s.tabHidden}>
              <div className={s.field}>
                <label>Mavzu nomi ({tab.label})</label>
                <input name={`nomi_${tab.key}`} value={form[`nomi_${tab.key}`]} onChange={handleChange} className={s.input} />
              </div>
              <div className={s.field}>
                <label>Qisqacha tavsif ({tab.label})</label>
                <textarea name={`short_text_${tab.key}`} value={form[`short_text_${tab.key}`]} onChange={handleChange} className={s.textarea} rows={3} />
              </div>
              <div className={s.field}>
                <label>Kalit so'zlar ({tab.label})</label>
                <input name={`key_word_${tab.key}`} value={form[`key_word_${tab.key}`]} onChange={handleChange} className={s.input} />
              </div>
              <div className={s.field}>
                <label>Video havolasi ({tab.label})</label>
                <input name={`videolink_${tab.key}`} value={form[`videolink_${tab.key}`]} onChange={handleChange} className={s.input} placeholder="https://youtu.be/..." />
              </div>
              <div className={s.field}>
                <label>Ma'ruza matni ({tab.label})</label>
                <textarea name={`maruza_matn_${tab.key}`} value={form[`maruza_matn_${tab.key}`]} onChange={handleChange} className={s.textarea} rows={5} />
              </div>
            </div>
          ))}

          {/* Fayllar */}
          <div className={s.row}>
            <div className={s.field}>
              <label>Rasmini yuklash (mrasmi_uz)</label>
              <input type="file" name="mrasmi_uz" ref={imgRef} accept="image/*" onChange={handleChange} className={s.inputFile} />
            </div>
            <div className={s.field}>
              <label>Ma'ruza fayli (maruza_file_uz)</label>
              <input type="file" name="maruza_file_uz" ref={fileRef} onChange={handleChange} className={s.inputFile} />
            </div>
          </div>

          {error && <p className={s.error}>{error}</p>}
          {success && <p className={s.successMsg}>{success}</p>}

          <div className={s.formActions}>
            <button type="submit" className={s.btnPrimary} disabled={saving}>
              {saving ? 'Saqlanmoqda...' : (editingId ? 'Yangilash' : 'Saqlash')}
            </button>
            <button type="button" className={s.btnSecondary} onClick={() => setView('list')}>
              Bekor qilish
            </button>
          </div>
        </form>
      )}

      {/* Удаление — подтверждение */}
      {deleteId && (
        <div className={s.modalOverlay}>
          <div className={s.modal}>
            <h3>Mavzuni o'chirish</h3>
            <p>Haqiqatan ham bu mavzuni o'chirmoqchimisiz?</p>
            <div className={s.modalActions}>
              <button className={s.btnDelete} onClick={handleDelete}>O'chirish</button>
              <button className={s.btnSecondary} onClick={() => setDeleteId(null)}>Bekor qilish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
